<script>
    import {unlock,unlock_requested,wallet_injected,target_mainnet} from "./stores/wallet";
    import {state,
        buttonsMinted,
    } from "./stores/contractButtons";
    import {
        solved
    } from "./stores/contractTreasure";


    import TreasureHunt from "./components/TreasureHunt.svelte";
    import Home from "./components/Home.svelte";

    async function doUnlock(){
        await unlock();
    }

    let page = "home"
</script>

<div>
    {#if $state  === "initial"}
        {#if !$unlock_requested}
            <button on:click={doUnlock}>
                Connect Metamask
            </button>
        {:else}
            Unlock requested...
        {/if}

    {:else if $state  === "loading"}
        Loading...
    {:else if $state  === "error"}
        Error with network connection
    {:else if $state  === "network"}
        Incorrect network
    {:else}
        {#if page === "home"}
            {#if $buttonsMinted === 4}
                <h1>ALL BUTTONS HAVE BEEN MINTED.</h1>
                <h2><button on:click={()=>{page = "hunt"}}>Begin the hunt</button></h2>
            {/if}
            <Home />
        {:else }
            <TreasureHunt />
        {/if}
    {/if}
</div>

